<template>
	<div class="form-checkbox-set">
		<div v-show="selectButtons" class="field has-addons">
			<p class="control">
				<button class="button select-all" @click.prevent="selectAll">
					Select all
				</button>
			</p>
			<p class="control">
				<button class="button clear-all" @click.prevent="deselectAll">
					Clear all
				</button>
			</p>
		</div>

		<ul>
			<li v-for="{ value, label } in options" :key="value">
				<b-checkbox v-model="selected" :native-value="value">
					{{ label }}
				</b-checkbox>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "FieldCheckboxSet",
	props: {
		selectButtons: {
			type: Boolean,
			default: () => false
		},
		options: {
			type: Array,
			required: true
		},
		disabled: {
			type: Boolean,
			default: () => false
		},
		preSelect: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			selected: []
		};
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		}
	},
	created() {
		if (this.preSelect) {
			this.selected = this.preSelect;
		}
	},
	methods: {
		selectAll() {
			this.selected = this.options.map((o) => o.value);
		},
		deselectAll() {
			this.selected = [];
		}
	}
};
</script>

<style lang="scss" scoped>
.has-addons {
	margin-bottom: 1.5em;
}
.form-checkbox-set {
	margin-bottom: 1em;
}
li {
	margin-bottom: 0.5em;
}
</style>
